import { api } from "./api";

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const s = document.createElement("script");
    s.src = src;
    s.onload = resolve;
    s.onerror = () => reject(new Error("Could not load checkout"));
    document.body.appendChild(s);
  });

export const payWithRazorpay = async (plan) => {
  await loadScript("https://checkout.razorpay.com/v1/checkout.js");
  const { data } = await api.post("/payments/razorpay/order", { plan });
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: data.key_id,
      amount: data.amount,
      currency: data.currency,
      order_id: data.order_id,
      name: "Rezume Ink",
      description: `${plan === "yearly" ? "Yearly" : "Monthly"} access`,
      prefill: { name: data.name, email: data.email },
      theme: { color: "#10B981" },
      handler: async (res) => {
        try { await api.post("/payments/razorpay/verify", res); resolve(); } catch (e) { reject(e); }
      },
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.on("payment.failed", (r) => reject(new Error(r.error?.description || "Payment failed")));
    rzp.open();
  });
};

